import React from 'react';
import T from 'prop-types';

import { BILLING_CYCLE_MONTHLY, BILLING_CYCLE_YEARLY } from '../../constants/payment';

import { Container, Label, StyledSwitch } from './style';

const BillingCycleSwitch = ({ defaultChecked, onChange }) => {
  const handleChange = (v) => {
    if (v === true) {
      onChange(BILLING_CYCLE_YEARLY);
    }

    if (v === false) {
      onChange(BILLING_CYCLE_MONTHLY);
    }
  };

  return (
    <Container>
      <Label>Monthly</Label>
      <StyledSwitch defaultChecked={defaultChecked} onChange={handleChange} />
      <Label>Yearly</Label>
    </Container>
  );
};

BillingCycleSwitch.propTypes = {
  onChange: T.func.isRequired,

  defaultChecked: T.bool,
};

BillingCycleSwitch.defaultProps = {
  defaultChecked: true,
};

export default BillingCycleSwitch;
